<mat-card class="dialog-card">
  <button class="close-btn" mat-icon-button (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>

  <h2>¿Cómo facturo y reclamo mi comisión?</h2>
  <p>
    ¡Es muy fácil! Generamos tu auto-factura, te la enviamos por email y realizamos el pago automáticamente. 
    Solo necesitas comprobar que los 
    <span class="highlight">datos de facturación y el método de pago</span> son correctos.  
    Una vez tengamos toda tu información actualizada y validada por nuestro equipo de finanzas, el sistema quedará activado.
  </p>

  <p>
    Recuerda que la comisión se paga mensualmente bajo estas condiciones:
  </p>

  <ul>
    <li>
        La <strong>comisión se adjudica</strong> cuanto el cliente comienza a disfrutar del servicio.
    </li>
    <li>
      La <strong>auto-factura</strong> se genera automáticamente el día 15 del mes siguiente a la adjundicación de la comisión.
    </li>
    <li>
      Incluye la comisión de todas las <strong>reservas completadas el mes anterior</strong>, independientemente de cuánta se reservaron.
    </li>
    <li>
      Si la comisión no alcanza un <strong>mínimo de 50 €</strong>, se acumulará para el siguiente mes y no se generará auto-factura.
    </li>
  </ul>

  <p>
    Si prefieres seguir enviando tus facturas personalmente, o si tienes dudas sobre la auto-facturación, 
    contáctanos en  
    <a href="mailto:contacta@mylocker.site">
      contacta@mylocker.site
    </a>
  </p>

  <!--
  <p><strong>Nuestros datos de facturación son:</strong></p>
  <p>
    Nombre o razón social: <strong>LORENA BAREA MONTEMAYOR</strong><br />
    CIF: <strong>76639766V</strong><br />
    Dirección: 
    <span class="highlight">
      CALLE NOSQUERA, 2, LOCAL 7. 29008 MÁLAGA - (MÁLAGA)
    </span>
  </p>
    -->

  <h3>¿Qué pasa si no tengo una factura?</h3>
  <p>
    Como empresa necesitamos estas facturas para poder realizar el pago. 
    De esta forma tú puedes cobrar tu comisión, siempre que estés registrado como empresa o autónomo.
  </p>

  <p>
    Si no puedes emitir facturas, siempre puedes usar tu comisión para 
    <strong>disfrutar de nuestos servicios</strong>.
  </p>
</mat-card>
